module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C106"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C108"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_INTRODUCTION#page_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__TALK_OF_THE_TOWN__Beginnings#page_6"
    }
  }, [_vm._v("1. TALK OF THE TOWN: Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__UP_THE_NECK__Pretenders#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. UP THE NECK: "), _c('em', [_vm._v("Pretenders")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__BIRDS_OF_PARADISE__Extended_P#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. BIRDS OF PARADISE: "), _c('em', [_vm._v("Extended Play")]), _vm._v(" and "), _c('em', [_vm._v("Pretenders II")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__TIME_THE_AVENGER__Learning_to#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. TIME THE AVENGER: "), _c('em', [_vm._v("Learning to Crawl")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__DON_T_GET_ME_WRONG__Get_Close#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. DON’T GET ME WRONG: "), _c('em', [_vm._v("Get Close")]), _vm._v(" and "), _c('em', [_vm._v("Packed!")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__LEGALISE_ME__Last_of_the_Inde#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. LEGALISE ME: "), _c('em', [_vm._v("Last of the Independents")]), _vm._v(" and "), _c('em', [_vm._v("¡Viva El Amor!")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7__COMPLEX_PERSON__Loose_Screw_a#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. COMPLEX PERSON: "), _c('em', [_vm._v("Loose Screw")]), _vm._v(" and "), _c('em', [_vm._v("Break Up the Concrete")])])]), _vm._v(" "), _c('p', {
    staticClass: "C108"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8__YOU_OR_NO_ONE__Fidelity___Sto#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. YOU OR NO ONE: "), _c('em', [_vm._v("Fidelity!")]), _vm._v(", "), _c('em', [_vm._v("Stockholm")]), _vm._v(", and "), _c('em', [_vm._v("Reckless")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_ACKNOWLEDGMENTS#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_SOURCES_AND_NOTES#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOURCES AND NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_SELECTED_DISCOGRAPHY#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SELECTED DISCOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_INDEX#page_185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 72
// module chunks = 0